import {AUTH} from 'src/shared/auth/actions';
import {LOAD_USER_COMPLETE} from 'src/shared/user/actions';
import {waitUntil} from 'src/shared/events';
import {token} from 'src/shared/auth/selectors';
import {fetchWithToken} from 'src/shared/api';
import {enrollment, outageOptIn} from 'src/shared/config/urls';
import {
  createFetchResourceAction,
  createAction,
  createSuccessAction,
  createErrorAction,
} from 'src/shared/utils/resource';

export const LOAD_SMS_ENROLLMENT_START = 'LOAD_SMS_ENROLLMENT_START';
export const LOAD_SMS_ENROLLMENT_SUCCESS = 'LOAD_SMS_ENROLLMENT_SUCCESS';
export const LOAD_SMS_ENROLLMENT_ERROR = 'LOAD_SMS_ENROLLMENT_ERROR';
export const LOAD_SMS_ENROLLMENT_COMPLETE = 'LOAD_SMS_ENROLLMENT_COMPLETE';

export const enrollmentUrl = mobileNumber => state => enrollment(state, mobileNumber);

export const loadSmsEnrollment = mobileNumber => createFetchResourceAction({
  start: LOAD_SMS_ENROLLMENT_START,
  success: LOAD_SMS_ENROLLMENT_SUCCESS,
  error: LOAD_SMS_ENROLLMENT_ERROR,
  complete: LOAD_SMS_ENROLLMENT_COMPLETE,
  waitUntil: [AUTH, LOAD_USER_COMPLETE],
  url: enrollmentUrl(mobileNumber),
  token,
  fetchOptions: {method: 'POST', headers: {Client: 'dotcom_support'}},
});

export const CREATE_OUTAGE_SMS_ENROLLMENT_START = 'CREATE_OUTAGE_SMS_ENROLLMENT_START';
export const CREATE_OUTAGE_SMS_ENROLLMENT_SUCCESS = 'CREATE_OUTAGE_SMS_ENROLLMENT_SUCCESS';
export const CREATE_OUTAGE_SMS_ENROLLMENT_ERROR = 'CREATE_OUTAGE_SMS_ENROLLMENT_ERROR';
export const CREATE_OUTAGE_SMS_ENROLLMENT_COMPLETE = 'CREATE_OUTAGE_SMS_ENROLLMENT_COMPLETE';

export const createOutageSmsEnrollment = phoneNumber => async (dispatch, getState) => {
  const actionStartTime = window.performance.now();

  dispatch(createAction(CREATE_OUTAGE_SMS_ENROLLMENT_START));
  await waitUntil(AUTH, LOAD_USER_COMPLETE);
  const requestStartTime = window.performance.now();
  const response = await fetchWithToken(
    outageOptIn(getState()),
    token(getState()),
    {
      method: 'POST',
      body: `{"phoneNumber": "${phoneNumber}"}`,
      headers: {'Content-Type': 'application/json'},
    }
  );
  const requestEndTime = window.performance.now();
  try {
    const json = await response.json();
    if (response.ok) {
      dispatch(createSuccessAction(CREATE_OUTAGE_SMS_ENROLLMENT_SUCCESS, {status: 'ENROLLED'}));
    } else if (json?.error?.errorDetails?.[0]?.errorCode === '10412') {
      dispatch(createSuccessAction(CREATE_OUTAGE_SMS_ENROLLMENT_SUCCESS, {status: 'ALREADY_ENROLLED'}));
    } else {
      dispatch(createErrorAction(CREATE_OUTAGE_SMS_ENROLLMENT_ERROR, new Error(response.status)));
    }
  } catch (error) {
    dispatch(createErrorAction(CREATE_OUTAGE_SMS_ENROLLMENT_ERROR, new Error(response.status)));
  } finally {
    dispatch(createAction(CREATE_OUTAGE_SMS_ENROLLMENT_COMPLETE, {
      timings: {
        action: window.performance.now() - actionStartTime,
        request: requestEndTime - requestStartTime,
      },
    }));
  }
};
